var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Button',{staticClass:"btn-color1",attrs:{"loading":_vm.loader},on:{"click":_vm.refreshPixelMetrics}},[_vm._v(" Atualizar planilha ")]),_c('br'),(_vm.message)?_c('small',{staticClass:"mt-2"},[_vm._v("Atualização está sendo processada!")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }